"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MonotoneChainSelectAction = _interopRequireDefault(require("../../index/chain/MonotoneChainSelectAction"));

var _MonotoneChain = _interopRequireDefault(require("../../index/chain/MonotoneChain"));

var _ItemVisitor = _interopRequireDefault(require("../../index/ItemVisitor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MCIndexPointSnapper =
/*#__PURE__*/
function () {
  function MCIndexPointSnapper() {
    _classCallCheck(this, MCIndexPointSnapper);

    MCIndexPointSnapper.constructor_.apply(this, arguments);
  }

  _createClass(MCIndexPointSnapper, [{
    key: "snap",
    value: function snap() {
      if (arguments.length === 1) {
        var hotPixel = arguments[0];
        return this.snap(hotPixel, null, -1);
      } else if (arguments.length === 3) {
        var _hotPixel = arguments[0],
            parentEdge = arguments[1],
            hotPixelVertexIndex = arguments[2];

        var pixelEnv = _hotPixel.getSafeEnvelope();

        var hotPixelSnapAction = new HotPixelSnapAction(_hotPixel, parentEdge, hotPixelVertexIndex);

        this._index.query(pixelEnv, new (
        /*#__PURE__*/
        function () {
          function _class() {
            _classCallCheck(this, _class);
          }

          _createClass(_class, [{
            key: "visitItem",
            value: function visitItem(item) {
              var testChain = item;
              testChain.select(pixelEnv, hotPixelSnapAction);
            }
          }, {
            key: "interfaces_",
            get: function get() {
              return [_ItemVisitor.default];
            }
          }]);

          return _class;
        }())());

        return hotPixelSnapAction.isNodeAdded();
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MCIndexPointSnapper;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return MCIndexPointSnapper;
}();

exports.default = MCIndexPointSnapper;

var HotPixelSnapAction =
/*#__PURE__*/
function (_MonotoneChainSelectA) {
  _inherits(HotPixelSnapAction, _MonotoneChainSelectA);

  function HotPixelSnapAction() {
    var _this;

    _classCallCheck(this, HotPixelSnapAction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HotPixelSnapAction).call(this));
    HotPixelSnapAction.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(HotPixelSnapAction, [{
    key: "isNodeAdded",
    value: function isNodeAdded() {
      return this._isNodeAdded;
    }
  }, {
    key: "select",
    value: function select() {
      if (arguments.length === 2 && Number.isInteger(arguments[1]) && arguments[0] instanceof _MonotoneChain.default) {
        var mc = arguments[0],
            startIndex = arguments[1];
        var ss = mc.getContext();

        if (this._parentEdge !== null) {
          if (ss === this._parentEdge && startIndex === this._hotPixelVertexIndex) return null;
        }

        this._isNodeAdded = this._hotPixel.addSnappedNode(ss, startIndex);
      } else return _get(_getPrototypeOf(HotPixelSnapAction.prototype), "select", this).apply(this, arguments);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return HotPixelSnapAction;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return HotPixelSnapAction;
}(_MonotoneChainSelectAction.default);

HotPixelSnapAction.constructor_ = function () {
  this._hotPixel = null;
  this._parentEdge = null;
  this._hotPixelVertexIndex = null;
  this._isNodeAdded = false;
  var hotPixel = arguments[0],
      parentEdge = arguments[1],
      hotPixelVertexIndex = arguments[2];
  this._hotPixel = hotPixel;
  this._parentEdge = parentEdge;
  this._hotPixelVertexIndex = hotPixelVertexIndex;
};

MCIndexPointSnapper.HotPixelSnapAction = HotPixelSnapAction;

MCIndexPointSnapper.constructor_ = function () {
  this._index = null;
  var index = arguments[0];
  this._index = index;
};